/* Ela Decora — Dynamic Labels */
(function(){
  /* Ler configs globais */
  var cfgEl = document.getElementById('eda-labels-config');
  var cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent); } catch(e) {}

  /* Esconder badges automáticos conforme config */
  if (!cfg.auto_novo) {
    document.querySelectorAll('[data-auto="novo"]').forEach(function(el){ el.style.display='none'; });
  } else {
    document.querySelectorAll('[data-auto="novo"]').forEach(function(el){
      var days = parseInt(el.dataset.days) || 0;
      if (days >= (cfg.auto_novo_dias || 14)) { el.style.display='none'; return; }
      el.style.background = cfg.auto_novo_cor || '#0a775a';
      el.style.color = cfg.auto_novo_cor_texto || '#ffffff';
      el.style.fontSize = (cfg.auto_novo_tamanho || 11) + 'px';
      var emoji = cfg.auto_novo_emoji ? cfg.auto_novo_emoji + ' ' : '';
      el.textContent = emoji + (cfg.auto_novo_texto || 'Novo');
      var wrap = el.closest('.eda-labels-wrap');
      if (wrap && cfg.auto_novo_posicao) wrap.className = 'eda-labels-wrap pos-' + cfg.auto_novo_posicao;
    });
  }

  if (!cfg.auto_estoque) {
    document.querySelectorAll('[data-auto="estoque"]').forEach(function(el){ el.style.display='none'; });
  } else {
    document.querySelectorAll('[data-auto="estoque"]').forEach(function(el){
      var qty = el.dataset.qty || '';
      var texto = (cfg.auto_estoque_texto || 'Últimas unidades').replace('{qty}', qty);
      var emoji = cfg.auto_estoque_emoji ? cfg.auto_estoque_emoji + ' ' : '';
      el.textContent = emoji + texto;
      el.style.background = cfg.auto_estoque_cor || '#fff3e0';
      el.style.color = cfg.auto_estoque_cor_texto || '#e65100';
      el.style.fontSize = (cfg.auto_estoque_tamanho || 11) + 'px';
      var wrap = el.closest('.eda-labels-wrap');
      if (wrap && cfg.auto_estoque_posicao) wrap.className = 'eda-labels-wrap pos-' + cfg.auto_estoque_posicao;
    });
  }

  /* Labels dinâmicas da seção config */
  var dataEl = document.getElementById('eda-labels-data');
  if (!dataEl) return;
  var labels;
  try { labels = JSON.parse(dataEl.textContent); } catch(e) { return; }
  if (!labels || !labels.length) return;

  var cards = document.querySelectorAll('.eda-labels-dynamic');
  cards.forEach(function(card){
    var pid = card.dataset.productId;
    var price = parseInt(card.dataset.productPrice) || 0;
    var tags = (card.dataset.productTags || '').split(',');
    var cols = (card.dataset.productCollections || '').split(',');

    labels.forEach(function(lb){
      if (!lb.ativo) return;

      /* Sem filtro (produto/collection/tag) = aplica em todos os produtos */
      var hasFilter = (lb.product_id && lb.product_id > 0) || (lb.collection_id && lb.collection_id > 0) || (lb.tag && lb.tag.length > 0);
      var match = !hasFilter;

      /* Match por produto específico */
      if (lb.product_id && String(lb.product_id) === pid) match = true;

      /* Match por collection */
      if (lb.collection_id && cols.indexOf(String(lb.collection_id)) !== -1) match = true;

      /* Match por tag */
      if (lb.tag && lb.tag.length > 0) {
        var lbTag = lb.tag.toLowerCase().trim();
        for (var i = 0; i < tags.length; i++) {
          if (tags[i].trim() === lbTag) { match = true; break; }
        }
      }

      if (!match) return;

      /* Filtro por faixa de preço (price em centavos, settings em R$) */
      if (lb.price_min > 0 && price < lb.price_min * 100) return;
      if (lb.price_max > 0 && price > lb.price_max * 100) return;

      card.className = 'eda-labels-dynamic pos-' + lb.posicao;
      card.style.width = lb.estilo === 'image' ? lb.largura + '%' : 'auto';

      if (lb.estilo === 'image' && lb.imagem && lb.imagem.length > 2) {
        card.innerHTML += '<img src="' + lb.imagem + '" alt="' + lb.text + '" loading="lazy">';
      } else if (lb.estilo === 'badge') {
        var emoji = lb.emoji ? lb.emoji + ' ' : '';
        card.innerHTML += '<span class="eda-label-text eda-label-text--badge" style="background:' + lb.cor + ';color:#fff;border-radius:4px">' + emoji + lb.text + '</span>';
      } else {
        /* Pill (Caraway style) */
        var emoji = lb.emoji ? lb.emoji + ' ' : '';
        card.innerHTML += '<span class="eda-label-text" style="background:' + lb.cor + ';color:' + lb.cor_texto + '">' + emoji + lb.text + '</span>';
      }
    });
  });
  /* Swipe dots update */
  document.querySelectorAll('.eda-card-swipe').forEach(function(sw){
    var dots = sw.parentElement.querySelectorAll('.eda-card-dot');
    if(!dots.length) return;
    sw.addEventListener('scroll', function(){
      var idx = Math.round(sw.scrollLeft / sw.offsetWidth);
      dots.forEach(function(d, i){ d.classList.toggle('on', i === idx); });
    });
  });
})();
